import { render, staticRenderFns } from "./ProsAndConsForm.vue?vue&type=template&id=7b1491ce&"
import script from "./ProsAndConsForm.vue?vue&type=script&lang=js&"
export * from "./ProsAndConsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports